





/**
 * PostHog Analytics Configuration
 *
 * Environment variables:
 * - VUE_APP_POSTHOG_KEY: Your PostHog project API key
 * - VUE_APP_POSTHOG_HOST: PostHog API host (default: https://app.posthog.com)
 */

export default {
  apiKey: process.env.VUE_APP_POSTHOG_KEY || "",
  apiHost: process.env.VUE_APP_POSTHOG_HOST || "https://app.posthog.com",

  // Autocapture configuration
  autocapture: {
    // DOM events to capture
    dom_event_allowlist: ["click", "submit", "change"],

    // Element types to capture
    element_allowlist: ["a", "button", "form", "input", "select", "textarea"],

    // CSS selector for elements to explicitly capture
    css_selector_allowlist: ["[data-ph-capture]"],

    // No URL allowlist (capture all pages)
    url_allowlist: null,

    // Elements to exclude from capture
    exclude_element_selectors: [
      "[data-ph-no-capture]",
      ".no-capture",
      "#logout-button",
      '[type="password"]',
    ],

    // Text/content to exclude
    exclude_text_content: ["password", "secret", "token", "api_key"],
  },

  // Session recording configuration
  sessionRecording: {
    enabled: true,
    // Record 10% of sessions to manage quota
    sampleRate: 1.0,
  },

  // Persistence: localStorage or cookie
  persistence: "localStorage",

  // We'll handle pageview tracking via router
  capture_pageview: false,

  // Capture when user leaves the page
  capture_pageleave: true,

  // Privacy: anonymize IP addresses
  ip_anonymization: true,

  // Disable in development mode (optional)
  // Can be overridden with VUE_APP_POSTHOG_DISABLED
  disable:
    process.env.NODE_ENV === "development" &&
    process.env.VUE_APP_POSTHOG_DISABLED === "true",

  // Development mode: log events to console
  debug: process.env.NODE_ENV === "development",

  // Advanced configuration
  advanced_disable_decide: false,
  disable_session_recording: false,
  disable_compression: false,
  disable_persistence: false,

  // Performance
  request_batching: true,
  request_queue_flush_interval: 3000, // 3 seconds

  // Feature flags
  feature_flag_request_header_only: false,

  // Loading delay (ms) - wait before capturing
  capture_copied_text: true,
};
